import React, { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { eventJournalerAtom, persistenceOrchestratorAtom } from '../../atoms/event-journal-atoms';
import { studioStoreAtom } from '../../atoms/studio-store';
import { PersistenceOrchestrator } from '../persistence-orchestrator';
type PropsT = {
  children: React.ReactNode;
};
export const PersistenceOrchestratorInitializer = ({
  children
}: PropsT) => {
  const studioStore = useAtomValue(studioStoreAtom);
  const journaler = useAtomValue(eventJournalerAtom);
  const setPersistenceOrchestrator = useSetAtom(persistenceOrchestratorAtom);
  useEffect(() => {
    if (studioStore === null || journaler === null) {
      return;
    }
    const orchestrator = new PersistenceOrchestrator([studioStore, journaler]);
    setPersistenceOrchestrator(orchestrator);
    orchestrator.start();
    const onBeforeUnload = () => void orchestrator.flushToIdb();
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      orchestrator.dispose();
      setPersistenceOrchestrator(null);
    };
  }, [studioStore, journaler, setPersistenceOrchestrator]);
  return <>{children}</>;
};